import * as React from 'react';
import { HorizontalSeparator } from './HorizontalSeparator';

import { SvgCaretDown } from '@itwin/itwinui-icons-react';
import { Avatar, getUserColor } from '@itwin/itwinui-react';
import { User } from 'oidc-client';
import { useThemeContext } from '../../../context';
import { AuthService } from '../../../services';
import { themedText } from '../../../styles/SharedStyles';
import { DropdownComponent } from './DropDownComponent';
import { Menu } from './Menu';
import { MenuItem } from './MenuItem';
import { PopoverBorder } from './PopOverBorder';

export interface UserIconMenuProps {
  user: User;
  visibleUserMenu: boolean;
  image?: React.ReactElement;
  className?: string;
  onShowUserMenu: (bShow: boolean) => any;
  onSignoutClick: () => Promise<void>;
  onViewProfileClick: () => any;
}

export function UserIconMenu({
  user,
  visibleUserMenu,
  image,
  className,
  onShowUserMenu,
  onSignoutClick,
  onViewProfileClick,
}: UserIconMenuProps): JSX.Element {
  const theme = useThemeContext();

  const fullName = AuthService.getFullName(user);
  const initials = AuthService.getInitials(user);
  const userColor = getUserColor(user.profile.email ?? fullName);

  return (
    <DropdownComponent
      visible={visibleUserMenu}
      onShow={onShowUserMenu}
      content={
        <PopoverBorder>
          <div
            style={{
              padding: '10px',
              paddingBottom: '20px',
              cursor: 'default',
              ...themedText(theme),
            }}
          >
            <div
              style={{
                fontSize: '18px',
                whiteSpace: 'nowrap',
              }}
            >
              {fullName}
            </div>
            <div
              style={{
                fontSize: '12px',
                fontWeight: 400,
                whiteSpace: 'nowrap',
                padding: 0,
                margin: 0,
              }}
            >
              {user.profile.email}
            </div>
          </div>
          <HorizontalSeparator />
          <Menu>
            <MenuItem onClick={onViewProfileClick}>View profile</MenuItem>
            <MenuItem onClick={onSignoutClick}>Sign out</MenuItem>
          </Menu>
        </PopoverBorder>
      }
    >
      <div
        className={className ?? ''}
        style={{
          display: 'flex',
          alignSelf: 'stretch',
          position: 'relative',
          userSelect: 'none',
        }}
      >
        <Avatar
          backgroundColor={userColor}
          title={fullName}
          abbreviation={initials}
          image={image}
        />
        <SvgCaretDown
          fill={'grey'}
          style={{ marginLeft: '4px' }}
          width={'8px'}
        />
      </div>
    </DropdownComponent>
  );
}
